import { useMutation } from "urql";

import { UpdatePengurusStatusDocument } from "../../../../graphql/generated.ts";

export function useUpdatePengurusStatus() {
  return useMutation(UpdatePengurusStatusDocument);
}
